// extracted by mini-css-extract-plugin
module.exports = {"container":"bg-z","products":"cg-z","cta":"dg-z","disabled":"eg-z"};